<template>
    <div v-if="options.length > 0">
        <ul class="afu-list-none afu-py-1 afu-px-0 afu-m-0">
            <li
                v-for="(opt, index) in options"
                :key="`option_${opt.occupation_id}_${index}`"
                :ref="`option_${index}`"
                :class="{ 'afu-bg-gray-100': arrowCounter === index }"
                class="af-occupation-select-item afu-text-sm afu-block afu-px-4 afu-py-2 afu-text-sm afu-leading-5 afu-text-black afu-cursor-pointer"
                tabindex="0"
                @click="select()"
                @mouseover="setArrowCounter(index)"
            >
                <div class="afu-flex afu-items-start">
                    <span class="afu-text-neutral-dark afu-pr-2">
                        <FontAwesomeIcon :icon="['far', 'plus']" />
                    </span>
                    <div>
                        <div class="afu-font-bold">
                            {{ opt.occupation_name }}
                        </div>

                        <div>
                            {{ opt.category_name }}
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
    <div v-else>
        <div class="afu-bg-gray-100 afu-py-2 afu-px-3">
            No result
        </div>
    </div>
</template>

<script>
    export default {
        name: 'C1ClsSelectSearchList',

        props: {
            options: {
                type: Array,
                default: () => [],
            },

            arrowCounter: {
                type: Number,
                default: 0,
            },
        },

        data() {
            return {};
        },

        methods: {
            setArrowCounter(index) {
                this.$emit('update:arrowCounter', index);
            },

            select() {
                this.$emit('select');
            },
        },
    };
</script>
